import { render, staticRenderFns } from "./ResourceCostMetricConfigurationPage.vue?vue&type=template&id=3715d200"
import script from "./ResourceCostMetricConfigurationPage.vue?vue&type=script&lang=ts"
export * from "./ResourceCostMetricConfigurationPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports